import { DataTable } from "@msuite/ui/table";
import { useResourceLinks } from "@/hooks/use-resource-links";
import type { ProjectPanelBaseProps } from "../types";
import { ProjectResourceLinksMenu } from "./project-resource-links-menu";
import { columns } from "./table-config";

export function ProjectResourceLinks({ projectId }: ProjectPanelBaseProps) {
	/** Hooks */
	const { resourceLinks, refetch, queryKey, isLoading } = useResourceLinks({ projectId });

	/** Render */
	return (
		<DataTable
			columns={columns}
			data={resourceLinks}
			isLoading={isLoading}
			queryKey={queryKey}
			menu={
				<ProjectResourceLinksMenu
					queryKey={queryKey}
					projectId={projectId}
				/>
			}
			refetch={refetch}
			persistenceKey="project-resource-links-table"
		/>
	);
}
